import { render, staticRenderFns } from "./modalRechazarCambioPrecio.vue?vue&type=template&id=efb1c730"
import script from "./modalRechazarCambioPrecio.vue?vue&type=script&lang=js"
export * from "./modalRechazarCambioPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports